
import React, { useEffect, useState } from 'react';
import { Layout, Spin, Alert, Typography, Row, Col, Divider } from 'antd';
import api from '../../services/api';
import ProfileSection from './ProfileSection';
import SecuritySection from './SecuritySection';
import ActivitySection from './ActivitySection';
import { User } from '../../types';
import './AccountPage.css';

const { Content } = Layout;
const { Title } = Typography;

const AccountPage: React.FC = () => {


  const [user, setUser] = useState<User | null >(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Fetch user data on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await api.get('/user/me');
        setUser(response.data); // Ensure the backend returns { user: {...} }
      } catch (err: any) {
        console.error(err);
        setError(err.response?.data?.message || 'Failed to fetch user data.');
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Update user state after profile update
  const handleUpdateUser = (updatedUser: User) => {
    setUser(updatedUser);
  };

  if (loading) {
    return (
      <Layout>
        <Content className="account-content">
          <Spin tip="Loading account details..." size="large" />
        </Content>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <Content className="account-content">
          <Alert message="Error" description={error} type="error" showIcon />
        </Content>
      </Layout>
    );
  }

  return (
    <Layout>
      <Content className="account-content">
        <Title level={2} className="account-title">My Account</Title>
        <Row gutter={[32, 32]}>
          <Col xs={24} lg={12}>
            {user && <ProfileSection user={user} onUpdate={handleUpdateUser} />}
          </Col>
          <Col xs={24} lg={12}>
          {user &&  <SecuritySection user={user} />}
          {user &&  <ActivitySection user={user} />}
          </Col>
        </Row>
        <Divider />
      </Content>
    </Layout>
  );
};

export default AccountPage;
